export const EXTERNAL_PASSPORT_APP_DOMAIN_NAME = 'carrierlogistics';

export const MONS_CUSTOMER_ID_HEADER = '_debug_amz-mons-customer';
export const PARTNER_ACCOUNT_ID_HEADER = '_debug_amz-mons-partner-account';

export const MONS_CUSTOMER_ID_SESSION = 'monsCustomerId';
export const PARTNER_ACCOUNT_ID_SESSION = 'partnerAccountId';
export const LPID_URL_QUERY = 'mons_sel_dir_paid';
export const CSRF_TOKEN_ID = 'anti-csrftoken-a2z';
